import script from "./Blood.vue?vue&type=script&setup=true&lang=js"
export * from "./Blood.vue?vue&type=script&setup=true&lang=js"

import "./Blood.vue?vue&type=style&index=0&id=014cb25f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014cb25f"]])

export default __exports__